import { useQuery } from '@tanstack/react-query';
import { apiService } from '../../../services/api';
import { PersonnelMember } from '../../../types/api';

// STD-015: server state for the Overview tab domain. apiService is imported
// here (a *.queries.ts file) per STD-016. Errors are toasted by the global
// QueryCache handler (lib/queryClient); meta.errorMessage supplies the i18n
// fallback.

export const overviewKeys = {
  all: ['overview'] as const,
  personnel: (roles: string[]) => [...overviewKeys.all, 'personnel', [...roles].sort()] as const,
};

export interface PersonnelData {
  pilots: PersonnelMember[];
  maintenanceEngineers: PersonnelMember[];
}

export function usePersonnelQuery(roles: string[] = ['pilot', 'maintenance']) {
  return useQuery({
    queryKey: overviewKeys.personnel(roles),
    meta: { skipGlobalErrorToast: true },
    queryFn: async (): Promise<PersonnelData> => {
      const response = await apiService.getOrganizationPersonnel(roles);
      const pilots: PersonnelMember[] = [];
      const maintenanceEngineers: PersonnelMember[] = [];
      response.personnel.forEach((person) => {
        if (person.roles.includes('pilot')) pilots.push(person);
        if (person.roles.includes('maintenance')) maintenanceEngineers.push(person);
      });
      return { pilots, maintenanceEngineers };
    },
  });
}
